import React, { Component } from 'react'
import style from './style.css'


export default class Avatar extends Component {
    render() {
        let props = this.props
        
        let styleInline = {
            ...props.style,
            width: `${props.size}px` || props.width || '',
            height: `${props.size}px` || props.height || '',
            border: `${props.border}` || '',
        }

        if(props.img) {
            styleInline['backgroundImage'] = `url('${props.img}')`
        }

        let image = () => (
            <div
                className={style.avatar}
                style={styleInline}
            />
        )
        
        return (
            <div className={`${style.avatarBox}`}>
                { (this.props.href && this.props.href) ? (
                    <a className={style.link} href={this.props.href}>
                        {image()}
                    </a>
                ) : image()}
                
                {props.children}
            </div>
        )
    } 
}

export const Bullet = props => (
    <span
        className={style.bullet}
        style={{
                ...props.style,
                width: `${props.size}px` || props.width || null,
                height: `${props.size}px` || props.height || null,
            }}
        >
        {props.children}
    </span>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Avatar/index.js